import React from 'react'
import { Box, Typography } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import { RelatedAsnSummary } from '../types'
import { getRelatedAsnPalette } from './relatedAsnStyles'

interface RelatedAsnRowProps {
  relatedAsn: RelatedAsnSummary
}

// Fila con el número y el estado de una Asn relacionada de una devolución mixta.
// El ícono y el color distinguen si ya está almacenada o si sigue pendiente.
export const RelatedAsnRow: React.FC<RelatedAsnRowProps> = ({ relatedAsn }) => {
  const palette = getRelatedAsnPalette(relatedAsn.asnStateId)

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        p: 1,
        borderRadius: '8px',
        backgroundColor: palette.background,
        border: `1px solid ${palette.border}`
      }}
    >
      {palette.isStored ? (
        <CheckCircleIcon sx={{ color: palette.icon, fontSize: 18 }} />
      ) : (
        <WarningAmberIcon sx={{ color: palette.icon, fontSize: 18 }} />
      )}
      {/* El número no se parte nunca: el operario lo compara contra la etiqueta */}
      <Typography
        variant='body2'
        sx={{ fontWeight: 600, flex: 1, whiteSpace: 'nowrap' }}
      >
        {relatedAsn.asnNumber}
      </Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary' }}>
        {relatedAsn.asnStateName}
      </Typography>
    </Box>
  )
}
